import * as React from 'react';
import { useContext, useEffect } from 'react';
import { ExperimentContext } from '../experiment-context';
import { ExperimentControl } from './experiment-control';
/**
 * Component that conditionally renders a control or
 * test variant child component given the results of an
 * experiment determined by the nearest `ExperimentContext`.
 */
export var Experiment = function (_a) {
    var name = _a.name, children = _a.children, _b = _a.logExposure, logExposure = _b === void 0 ? true : _b;
    var _c = useContext(ExperimentContext), getExposure = _c.getExposure, logExperiment = _c.logExperiment;
    var exposure;
    if (name) {
        exposure = getExposure(name);
    }
    var bucket = (exposure === null || exposure === void 0 ? void 0 : exposure.bucket) || 0;
    var control;
    var matchedComponent = children.find(function (child) {
        if (child.type === ExperimentControl) {
            // save control regardless if it's bucket 0 so we have a fallback
            control = child;
            // stop looking through the child collection if we already know we're in control
            if (bucket === 0) {
                return true;
            }
        }
        // otherwise keep cycling through until we find a matching variant
        return child.props.bucket === bucket;
    });
    // if we have no variant to match the current bucket
    if (!matchedComponent || matchedComponent === -1) {
        // then we should default to the control experience if we have one
        if (control) {
            return React.Children.only(control);
        }
        return null;
    }
    if (exposure && logExposure) {
        try {
            logExperiment(exposure);
        }
        catch (e) {
            // noop
        }
    }
    return React.Children.only(matchedComponent);
};
export var useExperiment = function (name, shouldLogExperiment) {
    var _a;
    var _b = useContext(ExperimentContext), getExposure = _b.getExposure, logExperiment = _b.logExperiment;
    var exposure = (_a = getExposure(name)) !== null && _a !== void 0 ? _a : {
        name: name,
        bucket: 0
    };
    useEffect(function () {
        if (exposure && shouldLogExperiment) {
            try {
                logExperiment(exposure);
            }
            catch (e) { }
        }
    }, [logExperiment]);
    return { exposure: exposure, logExperiment: logExperiment };
};
//# sourceMappingURL=experiment.js.map